<template>
  <v-dialog :value="value" max-width="520" persistent @input="$emit('input', $event)">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="cancelar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('contractV2.newTariff.title') }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="codTarifa"
                  :label="$t('contractV2.newTariff.code')"
                  :rules="[(v) => (!!v && v.length <= 20) || $t('contractV2.newTariff.codeRequired')]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="descricaoTarifa"
                  :label="$t('contractV2.newTariff.description')"
                  :rules="[(v) => (!!v && v.length <= 50) || $t('contractV2.newTariff.descriptionRequired')]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <!--
                  A categoria não é decoração: é ela que diz ao motor qual
                  componente de valor esta tarifa alimenta (fixo, variável ou
                  mão de obra).
                -->
                <v-select
                  v-model="idCategoria"
                  :items="categorias"
                  :label="$t('contractV2.newTariff.category')"
                  item-value="id_categoria"
                  item-text="descricao_categoria"
                  :rules="[(v) => !!v || $t('contractV2.newTariff.categoryRequired')]"
                  :hint="$t('contractV2.newTariff.categoryHint')"
                  persistent-hint
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-alert type="info" dense text class="mb-0">
                  {{ $t('contractV2.newTariff.warning') }}
                </v-alert>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="primary" :disabled="salvando" @click="cancelar">
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn dark color="primary" :loading="salvando" @click="criar">
          {{ $t('contractV2.newTariff.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';

/**
 * Criação de um tipo de tarifa sem sair do contrato.
 *
 * A tarifa é gravada no catálogo global assim que confirmada — mesmo que o
 * contrato não chegue a ser salvo. É o preço de reusar o insert de tarifa que
 * já existe, e o usuário é avisado disso no próprio dialog; uma tarifa sobrando
 * é inofensiva e se resolve na tela de tarifas.
 */
export default {
  name: 'NovaTarifaDialog',
  props: {
    value: { type: Boolean, default: false },
    /** Texto já digitado no autocomplete, aproveitado como descrição. */
    descricaoInicial: { type: String, default: '' },
    categorias: { type: Array, default: () => [] },
  },
  data: () => ({
    formValidado: true,
    salvando: false,
    codTarifa: null,
    descricaoTarifa: null,
    idCategoria: null,
  }),
  watch: {
    value(aberto) {
      if (!aberto) return;
      this.descricaoTarifa = this.descricaoInicial || null;
      this.codTarifa = this.sugereCodigo(this.descricaoInicial);
      // Variável é a categoria mais comum; o usuário confirma ou troca.
      this.idCategoria = 2;
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
  },
  methods: {
    sugereCodigo(descricao) {
      if (!descricao) return null;
      return String(descricao)
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .substring(0, 20) || null;
    },
    cancelar() {
      this.$emit('input', false);
    },
    criar() {
      this.$refs.form.validate();
      if (!this.formValidado) return;
      this.salvando = true;
      apiController.request(apiController.endpoints.insertTipotarifa, {
        data: {
          cod_tarifa: this.codTarifa,
          descricao_tarifa: this.descricaoTarifa,
          id_categoria: this.idCategoria,
        },
        onSuccess: (response) => {
          this.salvando = false;
          if (response.data && response.data.erro) {
            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
            return;
          }
          const categoria = (this.categorias || []).find(
            (c) => Number(c.id_categoria) === Number(this.idCategoria),
          );
          this.$emit('created', {
            id_tarifa: response.data.insertId,
            cod_tarifa: this.codTarifa,
            descricao_tarifa: this.descricaoTarifa,
            id_categoria: this.idCategoria,
            cod_categoria: categoria ? categoria.cod_categoria : null,
          });
          this.$emit('input', false);
        },
        onError: () => {
          this.salvando = false;
        },
      });
    },
  },
};
</script>
